import type { SupportedLanguage } from '@/app/types';
import type { ArtistProgramActivity } from './_apis';

type LocalizedValue =
  | string
  | { langs?: Partial<Record<SupportedLanguage, string>> }
  | Partial<Record<SupportedLanguage, string>>
  | null
  | undefined;

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const getArtistLocalizedText = (value: unknown, locale: SupportedLanguage = 'en') => {
  if (typeof value === 'string') return value;
  if (!isRecord(value)) return '';

  const source = isRecord(value.langs) ? value.langs : value;
  for (const key of [locale, 'en', 'zh']) {
    const text = source[key];
    if (typeof text === 'string' && text.trim()) return text;
  }

  const fallback = Object.values(source).find((text) => typeof text === 'string' && text.trim());
  return typeof fallback === 'string' ? fallback : '';
};

export const normalizeArtistActivityText = (activity: ArtistProgramActivity, locale: SupportedLanguage) => ({
  ...activity,
  title: getArtistLocalizedText(activity.title as LocalizedValue, locale),
  subtitle: getArtistLocalizedText(activity.subtitle as LocalizedValue, locale),
  content: getArtistLocalizedText(activity.content as LocalizedValue, locale),
});
